module.exports = {"en-US":{"components":{"lot-group-item-overlay":{"title":"Item details"}}}}